<div class="d-flex flex-column flex-fill overflow-hidden rounded-4 bg-white shadow-sm mt-2">
  <div class="d-flex flex-wrap align-items-center gap-2 pt-3 px-3">
    <h2 class="mb-0 fs-18 fw-600">
      Deposits History <span class="text-success">({{ sortedDeposits().length }})</span>
    </h2>

    <div class="d-flex flex-fill flex-wrap align-items-center justify-content-end gap-2">
      @if (canWriteDeals()) {
        <div ngbDropdown container="body" placement="bottom-end">
          <button class="btn btn-outline-primary btn-h42" type="button" ngbDropdownToggle>
            <i class="bi bi-download fs-16"></i>Import from
          </button>
          <div ngbDropdownMenu>
            <button class="dropdown-item btn-h42" (click)="imports.emit('projects')">
              <i class="bi bi-cash me-1"></i>Import from deposits defaults
            </button>
          </div>
        </div>
        <button
          type="button"
          class="btn btn-outline-danger btn-h42"
          (click)="confirmBulkDelete()"
          [disabled]="selectedDeposits.length === 0"
        >
          <i class="bi bi-trash fs-16"></i>
          Bulk Delete
        </button>
        <button type="button" class="btn btn-primary btn-h42" (click)="_depositService.addNewDeposits = true">
          <i class="bi bi-plus-lg fs-16"></i>
          New Deposit
        </button>
      }
    </div>
  </div>

  <p-dialog
    [header]="_depositService.depositId ? 'Edit Deposit' : 'New Deposit'"
    [visible]="_depositService.addNewDeposits"
    (visibleChange)="!$event && resetForm()"
    [modal]="true"
    [closable]="true"
    appendTo="body"
    [style]="{ width: '36rem', maxWidth: '95vw' }"
  >
    <form [formGroup]="form" class="d-flex flex-column gap-3 pt-1">
      <div class="row gy-3">
        <div class="col-sm-6">
          <generic-dropdown
            [items]="depositTypes()"
            [label]="'Deposit Type'"
            [placeholder]="'Select Deposit Type'"
            [required]="true"
            formControlName="depositTypeId"
            [allowSearch]="true"
            [clearable]="true"
            [disabled]="!canWriteDeals()"
            (ngModelChange)="onDepositTypeChange($event)"
          ></generic-dropdown>
        </div>
        <div class="col-sm-6">
          <label class="form-label">Due Date <span class="text-danger">*</span></label>
          <p-datePicker
            [appendTo]="'body'"
            inputId="dueDate"
            formControlName="depositDueDate"
            [showIcon]="true"
            dateFormat="mm/dd/yy"
            placeholder="Select Date"
            styleClass="w-100"
            [disabled]="!canWriteDeals()"
          ></p-datePicker>
        </div>
        @if (isSelectedDepositTypeOptions()) {
          <div class="col-sm-6">
            <generic-dropdown
              [items]="addendumChoices()"
              [label]="'Addendum'"
              [placeholder]="'Select Addendum'"
              [allowSearch]="true"
              [clearable]="true"
              formControlName="addendumId"
              [required]="addendumRequiredValidators"
              [disabled]="!canWriteDeals()"
            ></generic-dropdown>
          </div>
        }
        <div class="col-sm-6">
          <currency-input-field
            [label]="'Amount'"
            [placeholder]="'Amount'"
            [requiredLabel]="true"
            formControlName="depositAmount"
            [control]="form.get('depositAmount')"
            [disabled]="!canWriteDeals()"
          ></currency-input-field>
        </div>
      </div>
    </form>
    <ng-template #footer>
      <div class="d-flex justify-content-end gap-2 pt-1">
        <span class="btn btn-shadow" role="button" (click)="resetForm()">Cancel</span>
        @if (canWriteDeals()) {
          <button
            class="btn btn-primary"
            [disabled]="form.invalid"
            (click)="depositsSaved.emit()"
            appBtnLoader="add-update-deposit"
          >
            {{ _depositService.depositId ? 'Update' : 'Add' }}
          </button>
        }
      </div>
    </ng-template>
  </p-dialog>

  <div class="d-none d-md-flex flex-shrink-0 bg-light px-4 py-2 mt-3" style="min-width: 640px">
    <div class="w-50" style="min-width: 0">
      <span class="fs-14 fw-600 text-dark text-uppercase">Deposit</span>
    </div>
    <div class="w-50" style="min-width: 0">
      <span class="fs-14 fw-600 text-dark text-uppercase">Payment</span>
    </div>
  </div>

  <div class="d-flex d-md-none flex-shrink-0 bg-light rounded-3 px-3 py-2 mt-3">
    <span class="fs-14 fw-600 text-dark text-uppercase">Deposit / Payment</span>
  </div>

  <div class="flex-fill overflow-auto bg-light p-3 pt-0">
    <div class="d-none d-md-flex flex-column gap-2" style="min-width: 640px">
      @for (deposit of sortedDeposits(); track deposit.id) {
        @if (!deposit.payments.length) {
          <div class="d-flex bg-white rounded-3 shadow-sm overflow-hidden">
            <div
              class="w-50 d-flex align-items-start justify-content-between gap-2 px-3 py-3 border-end"
              style="min-width: 0"
              [class.bg-info-subtle]="isDepositSelected(deposit)"
            >
              <ng-container *ngTemplateOutlet="depositInfo; context: { $implicit: deposit }" />
            </div>
            <div
              class="w-50 d-flex align-items-center justify-content-center px-3 py-3"
              style="min-width: 0; min-height: 86px"
              [class.bg-info-subtle]="isDepositSelected(deposit)"
            >
              <ng-container *ngTemplateOutlet="noPaymentInfo; context: { $implicit: deposit }" />
            </div>
          </div>
        } @else {
          <div class="d-flex flex-column bg-white rounded-3 shadow-sm overflow-hidden">
            @for (payment of deposit.payments; track payment.id; let first = $first; let last = $last) {
              <div class="d-flex" [class.border-bottom]="!last">
                <div
                  class="w-50 d-flex align-items-start justify-content-between gap-2 px-3 py-3 border-end"
                  style="min-width: 0"
                  [class.bg-info-subtle]="isDepositSelected(deposit)"
                >
                  @if (first) {
                    <ng-container *ngTemplateOutlet="depositInfo; context: { $implicit: deposit }" />
                  }
                </div>
                <div
                  class="w-50 d-flex align-items-start justify-content-between gap-2 px-3 py-3"
                  style="min-width: 0"
                  [class.bg-info-subtle]="isDepositSelected(deposit)"
                >
                  <ng-container *ngTemplateOutlet="paymentInfo; context: { $implicit: payment, deposit: deposit }" />
                </div>
              </div>
            }
          </div>
        }
      }
    </div>

    <div class="d-flex d-md-none flex-column gap-3">
      @for (deposit of sortedDeposits(); track deposit.id) {
        <div
          class="d-flex flex-column overflow-hidden rounded-3 bg-white shadow-sm"
          [class.bg-info-subtle]="isDepositSelected(deposit)"
        >
          <div class="d-flex align-items-start justify-content-between gap-2 px-3 py-3">
            <ng-container *ngTemplateOutlet="depositInfo; context: { $implicit: deposit }" />
          </div>

          @if (!deposit.payments.length) {
            <div class="px-3 py-3 border-top">
              <ng-container *ngTemplateOutlet="noPaymentInfo; context: { $implicit: deposit }" />
            </div>
          } @else {
            @for (payment of deposit.payments; track payment.id) {
              <div class="d-flex align-items-start justify-content-between gap-2 px-3 py-3 border-top">
                <ng-container *ngTemplateOutlet="paymentInfo; context: { $implicit: payment, deposit: deposit }" />
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
</div>

<ng-template #noPaymentInfo let-deposit>
  <div
    class="d-flex flex-fill align-items-center justify-content-between gap-2 rounded-pill border px-3 py-2"
    style="border-style: dashed !important"
  >
    <span class="fs-14 fw-500 text-muted">No payment yet</span>
    @if (canWriteDeals()) {
      <button class="btn btn-outline-primary btn-h35 fs-14" (click)="onAddPayment(deposit)">
        <i class="bi bi-plus-lg me-0"></i>Record Payment
      </button>
    }
  </div>
</ng-template>

<ng-template #paymentInfo let-payment let-deposit="deposit">
  <div class="d-flex align-items-start gap-2">
    <div
      class="d-flex align-items-center justify-content-center rounded-4 bg-light flex-shrink-0"
      style="width: 48px; height: 48px"
      [class.cursor-pointer]="payment.paymentImages?.length"
      (click)="payment.paymentImages?.length && openPaymentImagesDialog(payment.paymentImages)"
    >
      <i class="bi bi-image text-muted"></i>
    </div>
    <div class="d-flex flex-column gap-1">
      <span
        class="fw-600 fs-16 text-success"
        [class.text-muted]="payment.returned"
        [class.text-decoration-line-through]="payment.returned"
      >
        {{ payment.paymentAmount | currencyFormat }}
      </span>
      <div class="d-flex flex-column flex-xl-row align-items-start align-items-xl-center gap-xl-3 gap-1">
        <span class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center gap-1 fs-12">
          <span class="text-muted">Ref:</span>
          <span class="fw-500">{{ payment.referenceNo || '-' }}</span>
        </span>
        <span class="d-flex align-items-center gap-1 fs-12">
          <span class="text-muted">Date:</span>
          <span class="fw-500">{{ payment.paymentDate | date: 'MM/dd/yyyy' }}</span>
        </span>
      </div>
      <span class="d-flex flex-column flex-xl-row align-items-start align-items-xl-center gap-1 fs-12">
        <span class="text-muted">Created By:</span>
        <span class="fw-500"
          >{{ payment.createdByUserName || '-' }} on {{ payment.createdAt | date: 'MM/dd/yyyy' }}</span
        >
      </span>
    </div>
  </div>
  <div class="d-flex flex-shrink-0 align-items-center gap-2">
    @if (payment.paymentImages?.length > 0) {
      <span class="text-primary cursor-pointer fs-14" (click)="openPaymentImagesDialog(payment.paymentImages)">
        <i class="bi bi-eye"></i>
      </span>
    }
    <span class="fs-16 fw-600" [class.text-danger]="payment.returned" [class.text-success]="!payment.returned">
      {{ payment.returned ? 'Returned' : 'Paid' }}
    </span>
    <div ngbDropdown container="body">
      <i class="bi bi-three-dots-vertical fs-16" role="button" ngbDropdownToggle></i>
      <div ngbDropdownMenu>
        @if (canWriteDeals()) {
          <button ngbDropdownItem (click)="onEditPayment(payment)">Edit</button>
          <button ngbDropdownItem (click)="onToggleReturned(payment)">
            {{ payment.returned ? 'Mark as Paid' : 'Mark as Returned' }}
          </button>
        }
        <button ngbDropdownItem (click)="onDownloadReceipt(payment)">Download receipt</button>
        @if (canWriteDeals()) {
          <button ngbDropdownItem class="text-danger" (click)="onDeleteDepositPayment(payment.id)">Delete</button>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #depositInfo let-deposit>
  <div class="d-flex align-items-start gap-2">
    @if (canWriteDeals()) {
      <div class="d-flex align-items-center pt-1">
        <input
          type="checkbox"
          class="form-check-input mt-0"
          [checked]="isDepositSelected(deposit)"
          [disabled]="deposit?.payments?.length > 0"
          (change)="toggleDepositSelection(deposit, $any($event.target).checked)"
        />
      </div>
    }
    <div class="d-flex flex-column gap-1">
      <span class="fw-600 fs-16">{{ deposit.depositType.name }}</span>
      <div class="d-flex flex-column gap-1">
        <span class="d-flex flex-column flex-xl-row align-items-start align-items-xl-center gap-1 fs-12">
          <span class="text-muted">Addendum:</span>
          <span class="fw-500">{{ getAddendumLabel(deposit?.addendumId) || '-' }}</span>
        </span>
        <span class="d-flex flex-column flex-xl-row align-items-start align-items-xl-center gap-1 fs-12">
          <span class="text-muted">Created By:</span>
          <span class="fw-500"
            >{{ deposit.createdByUserName || '-' }} on {{ deposit.createdAt | date: 'MM/dd/yyyy' }}</span
          >
        </span>
      </div>
    </div>
  </div>
  <div class="d-flex flex-shrink-0 align-items-start gap-2">
    <div class="d-flex flex-column align-items-end gap-1 text-end">
      <span class="fw-600 fs-16 text-success">{{ deposit.depositAmount | currencyFormat }}</span>
      <span class="d-flex align-items-center gap-1 fs-12">
        <span class="text-muted">Due:</span>
        <span class="fw-500">{{ deposit.depositDueDate | date: 'MM/dd/yyyy' }}</span>
      </span>
      @if (deposit.reminderSentAt) {
        <span class="d-flex align-items-center gap-1 fs-12">
          <span class="text-muted">Reminder sent:</span>
          <span class="fw-500">{{ deposit.reminderSentAt | date: 'MM/dd/yyyy' }}</span>
        </span>
      }
    </div>
    @if (!deposit?.payments?.length && canWriteDeals()) {
      <div ngbDropdown container="body">
        <i class="bi bi-three-dots-vertical fs-16" role="button" ngbDropdownToggle></i>
        <div ngbDropdownMenu>
          <button ngbDropdownItem (click)="onEditDeposit(deposit)">Edit</button>
          <button ngbDropdownItem class="text-danger" (click)="onDeleteDeposit(deposit.id)">Delete</button>
        </div>
      </div>
    }
  </div>
</ng-template>

<p-dialog
  header="Record Payment"
  [visible]="_depositService.addPayment"
  (visibleChange)="!$event && onCancelPayment()"
  [modal]="true"
  [closable]="true"
  appendTo="body"
  [style]="{ width: '32rem', maxWidth: '95vw' }"
>
  @if (activePaymentDeposit(); as activeDeposit) {
    <form [formGroup]="depositPaymentForm" class="d-flex flex-column gap-3">
      <div class="d-flex align-items-center justify-content-between rounded-3 border bg-warning-subtle px-3 py-2">
        <span class="fs-16 fw-600">{{ activeDeposit.depositType.name }} Deposit</span>
        <span class="fs-16 fw-600 text-success">{{ activeDeposit.depositAmount | currencyFormat }}</span>
      </div>

      <currency-input-field
        [label]="'Amount'"
        [placeholder]="'Amount *'"
        formControlName="paymentAmount"
        [control]="depositPaymentForm.get('paymentAmount')"
        [errormessage]="'Payment amount cannot be greater than the deposit amount'"
        [required]="true"
        [disabled]="!canWriteDeals()"
      ></currency-input-field>

      <div class="row gy-3">
        <div class="col-sm-6">
          <label class="form-label">Date <span class="text-danger">*</span></label>
          <p-datepicker
            [appendTo]="'body'"
            [showIcon]="true"
            [dateFormat]="'mm/dd/yy'"
            [placeholder]="'Select Date *'"
            formControlName="paymentDate"
            styleClass="w-100"
            [disabled]="!canWriteDeals()"
          ></p-datepicker>
        </div>
        <div class="col-sm-6">
          <input-field
            [label]="'Reference No.'"
            [type]="'text'"
            [placeholder]="'e.g CHQ-102412'"
            formControlName="referenceNo"
            [disabled]="!canWriteDeals()"
          ></input-field>
        </div>
      </div>

      <div class="d-flex align-items-center gap-2">
        <p-toggleSwitch formControlName="returned" [disabled]="!canWriteDeals()"></p-toggleSwitch>
        <span class="fs-14 fw-500">{{ depositPaymentForm.get('returned')?.value ? 'Returned' : 'Paid' }}</span>
      </div>

      @if (canWriteDeals()) {
        <div class="d-flex flex-column gap-2">
          <label class="form-label mb-0">Cheque Image</label>
          <div class="d-flex flex-column align-items-center gap-3 rounded-4 border bg-light px-3 py-3">
            <button type="button" class="btn btn-outline-secondary btn-h35 fs-14" (click)="paymentFileInput.click()">
              <i class="bi bi-upload me-1"></i>Upload Images
            </button>
            <span class="fs-14 text-muted">Drag and drop image here to upload.</span>
            <input
              #paymentFileInput
              type="file"
              class="d-none"
              accept="image/*"
              multiple
              (change)="onFileSelected($event)"
            />
          </div>

          @if (attachments().length > 0) {
            <div class="d-flex flex-column gap-1" style="max-height: 15rem; overflow-y: auto">
              @for (attachment of attachments(); track $index) {
                <div class="d-flex align-items-center justify-content-between gap-2 px-3 py-2 rounded-3 border">
                  @if (attachment.file && attachment.progress !== null) {
                    <span class="d-flex align-items-center gap-2 fs-12 text-muted">
                      <i class="pi pi-spin pi-spinner"></i>
                      Image {{ $index + 1 }} — {{ attachment.progress }}%
                    </span>
                  } @else {
                    <span class="d-flex align-items-center gap-2 fs-12">
                      <i class="pi pi-image text-muted"></i>
                      Image {{ $index + 1 }}
                    </span>
                  }
                  <span
                    class="text-danger fs-12 cursor-pointer d-flex align-items-center gap-1"
                    (click)="removeAttachment(attachment)"
                  >
                    <i class="pi pi-times fs-12"></i>
                    Remove
                  </span>
                </div>
              }
            </div>
          }
        </div>
      }
    </form>
  }
  <ng-template #footer>
    <div class="d-flex justify-content-end gap-2 pt-1">
      <span class="btn btn-shadow" role="button" (click)="onCancelPayment()">Cancel</span>
      @if (canWriteDeals()) {
        <button
          class="btn btn-primary"
          [disabled]="depositPaymentForm.invalid"
          (click)="onDepositPaymentFormSubmitted(activePaymentDeposit()!)"
          appBtnLoader="add-update-deposit-payment"
        >
          Record Payment
        </button>
      }
    </div>
  </ng-template>
</p-dialog>

<lib-link-list-dialog
  header="Cheque Images"
  [(visible)]="viewImagesDialogVisible"
  [items]="selectedPaymentImageLinks()"
  emptyMessage="No images available"
/>
